import axios from 'axios';
import { verifyEnvUrl } from 'util/verifyEnvUrl';

const prodUrl = 'https://api.acordofechado.com.br/whatsapp-utils';
const devUrl = 'https://api.acordofechado.com.br/whatsapp-utils-dev';


const whatsappUtilsApi = axios.create( {
	baseURL: verifyEnvUrl( prodUrl, devUrl )
} );

whatsappUtilsApi.interceptors.request.use( async config => {
	const token = localStorage.getItem( 'af-token' );
	if ( token ) {
		config.headers.Authorization = `Bearer ${token}`;
	}
	return config;
} );

export default whatsappUtilsApi;
